export default __webpack_public_path__ + "static/media/newehr.85c19fe5.png";